import React, { useEffect,useState } from "react";
import Swal from "sweetalert2";
import moment from "moment";
import {
  FaExclamationTriangle,
  FaEdit,
  FaEye,
  FaPaperPlane,
  FaTimes,
  FaExclamationCircle,
  FaCheckCircle,
  FaTimesCircle,
  FaInfoCircle,
  FaSpinner,
  FaHistory,
  FaUsers,
  FaMoneyBillWave,
  FaIdCard,
  FaUserGraduate,
  FaCreditCard,
  FaCalendarAlt,
  FaCalculator,
  FaPercent,
  FaChartLine,
} from "react-icons/fa";
import { FiCreditCard } from "react-icons/fi";

// =============================================================================
// 1. CUSTOM JSX MODAL – Family Check Dialog (controlled)
// =============================================================================
// ========== MISSING STATE ==========

const FamilyCheckDialog = ({
  isOpen,
  onClose,
  familyCheckResult,
  familyCode,
  onUpdate,
  onView,
  onSubmitNew,
}) => {
  if (!isOpen || !familyCheckResult) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "20px",
        backdropFilter: "blur(4px)",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
          width: "100%",
          maxWidth: "500px",
          maxHeight: "90vh",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "20px 24px",
            backgroundColor: "#fff3e0",
            borderBottom: "1px solid #ff9800",
          }}
        >
          <FaExclamationTriangle
            style={{
              fontSize: "24px",
              color: "#ff9800",
              marginRight: "12px",
              flexShrink: 0,
            }}
          />
          <h3
            style={{
              margin: 0,
              flex: 1,
              color: "#e65100",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
            Family Fee Record Already Exists
          </h3>
          <button
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              color: "#666",
              cursor: "pointer",
              padding: "4px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              transition: "background-color 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#f5f5f5")}
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "transparent")
            }
            onClick={onClose}
          >
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div
          style={{
            padding: "24px",
            flex: 1,
            overflowY: "auto",
          }}
        >
          <p
            style={{
              margin: "0 0 20px 0",
              color: "#555",
              lineHeight: 1.5,
            }}
          >
            {familyCheckResult.message}
          </p>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              padding: "16px",
              marginBottom: "24px",
              border: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "8px 0",
                borderBottom: "1px solid #e9ecef",
              }}
            >
              <span style={{ color: "#666", fontWeight: 500 }}>
                Family Code:
              </span>
              <strong
                style={{
                  color: "#4f46e5",
                  fontFamily: "'Monaco', 'Courier New', monospace",
                }}
              >
                {familyCheckResult.family_code}
              </strong>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "8px 0",
                borderBottom: "1px solid #e9ecef",
              }}
            >
              <span style={{ color: "#666", fontWeight: 500 }}>
                Students in Family:
              </span>
              <strong style={{ color: "#059669" }}>
                {familyCheckResult.data?.student_count_in_family || 0}
              </strong>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "8px 0",
              }}
            >
              <span style={{ color: "#666", fontWeight: 500 }}>
                Existing Fee Records:
              </span>
              <strong style={{ color: "#dc2626" }}>
                {familyCheckResult.data?.fee_record_count || 0}
              </strong>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div
          style={{
            padding: "20px 24px",
            backgroundColor: "#f8f9fa",
            borderTop: "1px solid #e9ecef",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "14px 20px",
              backgroundColor: "#4f46e5",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s",
              width: "100%",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#4338ca")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#4f46e5")}
            onClick={onUpdate}
          >
            <FaEdit />
            Update Existing Family Records
          </button>

          <button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "14px 20px",
              backgroundColor: "#059669",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s",
              width: "100%",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#047857")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#059669")}
            onClick={onView}
          >
            <FaEye />
            View Current Fee Setup
          </button>

          <button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "14px 20px",
              backgroundColor: "#f59e0b",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s",
              width: "100%",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#d97706")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#f59e0b")}
            onClick={onSubmitNew}
          >
            <FaPaperPlane />
            Submit New Anyway
          </button>

          <button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              padding: "14px 20px",
              backgroundColor: "#6b7280",
              color: "white",
              border: "none",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.2s",
              width: "100%",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#4b5563")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#6b7280")}
            onClick={onClose}
          >
            <FaTimes />
            Cancel
          </button>
        </div>

        {/* Warning */}
        <div
          style={{
            padding: "16px 24px",
            backgroundColor: "#fef2f2",
            borderTop: "1px solid #fecaca",
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
          }}
        >
          <FaExclamationCircle
            style={{
              fontSize: "18px",
              color: "#dc2626",
              flexShrink: 0,
              marginTop: "2px",
            }}
          />
          <span
            style={{
              color: "#b91c1c",
              fontSize: "14px",
              lineHeight: 1.4,
            }}
          >
            Warning: Creating a new record when one already exists may cause
            duplicate entries in the system.
          </span>
        </div>
      </div>
    </div>
  );
};

// =============================================================================
// 2. CONTROLLED SWAL MODALS (triggered by useEffect)
// =============================================================================

const Modals = ({
  // Family Check Dialog
  isFamilyCheckOpen,
  closeFamilyCheck,
  familyCheckResult,
  familyCode,
  onFamilyCheckUpdate,
  onFamilyCheckView,
  onFamilyCheckSubmitNew,

  // Family Details Modal
  isFamilyDetailsOpen,
  closeFamilyDetails,
  students,
  totalStudents,
  feeSummary,
  formatCurrency,

  // Student Details Modal
  isStudentDetailsOpen,
  closeStudentDetails,
  studentItem,

  // Fee Details Modal
  isFeeDetailsOpen,
  closeFeeDetails,

  // Fee Records Modal
  isFeeRecordsOpen,
  closeFeeRecords,
  feeRecords,
  onUpdateExisting,

  // Update Success Modal
  isUpdateSuccessOpen,
  closeUpdateSuccess,
  lastPending,
}) => {
  // ---------- Family Details Modal (Swal) ----------
  useEffect(() => {
    if (!isFamilyDetailsOpen) return;

    const generateFamilyDetailsHTML = () => {
      let studentsHTML = `
      <div style="
        font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
        color: #333; height:50vh;
        padding: 10px;
      ">
        <h4 style="
          color: #4f46e5;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #e5e7eb;
          font-size: 18px;
          font-weight: 600;
        ">
          Family Details: ${familyCode}
        </h4>
        
        <div style="
          margin-bottom: 25px;
          overflow-x: auto;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        ">
          <table style="
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
          ">
            <thead style="
              background-color: #4f46e5;
              color: white;
            ">
              <tr>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Student ID</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Name</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Class</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Section</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                ">Monthly Fee</th>
              </tr>
            </thead>
            <tbody>
      `;

      students.forEach((item) => {
        const student = item.student;
        const feeDetails = item.feeDetails || {};
        studentsHTML += `
        <tr style="
          border-bottom: 1px solid #e5e7eb;
          transition: background-color 0.2s;
        " onmouseover="this.style.backgroundColor='#f9fafb'" onmouseout="this.style.backgroundColor='transparent'">
          <td style="
            padding: 12px 16px;
            border-right: 1px solid #e5e7eb;
            font-family: 'Monaco', 'Courier New', monospace;
          ">${student.student_id || "N/A"}</td>
          <td style="
            padding: 12px 16px;
            border-right: 1px solid #e5e7eb;
            font-weight: 500;
          ">${student.name || "N/A"}</td>
          <td style="
            padding: 12px 16px;
            border-right: 1px solid #e5e7eb;
          ">${student.class || "N/A"}</td>
          <td style="
            padding: 12px 16px;
            border-right: 1px solid #e5e7eb;
          ">${student.section || "N/A"}</td>
          <td style="
            padding: 12px 16px;
            text-align: right;
            font-weight: 600;
            color: #059669;
            font-family: 'Monaco', 'Courier New', monospace;
          ">${formatCurrency(feeDetails.monthly_fee || 0)}</td>
        </tr>
      `;
      });

      studentsHTML += `
            </tbody>
          </table>
        </div>
        
        <div style="
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          padding: 20px;
          background-color: #f9fafb;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
        ">
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            background: white;
            border-radius: 6px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            border: 1px solid #e5e7eb;
          ">
            <span style="
              font-size: 14px;
              color: #6b7280;
              margin-bottom: 8px;
            ">Total Students</span>
            <strong style="
              font-size: 24px;
              color: #4f46e5;
              font-weight: 700;
            ">${totalStudents}</strong>
          </div>
          
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            background: white;
            border-radius: 6px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            border: 1px solid #e5e7eb;
          ">
            <span style="
              font-size: 14px;
              color: #6b7280;
              margin-bottom: 8px;
            ">Total Monthly Fee</span>
            <strong style="
              font-size: 24px;
              color: #059669;
              font-weight: 700;
              font-family: 'Monaco', 'Courier New', monospace;
            ">${formatCurrency(feeSummary.totalMonthlyFee)}</strong>
          </div>
          
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            background: white;
            border-radius: 6px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            border: 1px solid #e5e7eb;
          ">
            <span style="
              font-size: 14px;
              color: #6b7280;
              margin-bottom: 8px;
            ">Total Payable</span>
            <strong style="
              font-size: 24px;
              color: #dc2626;
              font-weight: 700;
              font-family: 'Monaco', 'Courier New', monospace;
            ">${formatCurrency(feeSummary.totalPayable)}</strong>
          </div>
        </div>
      </div>
      `;
      return studentsHTML;
    };

    Swal.fire({
      title: "Family Details",
      html: generateFamilyDetailsHTML(),
      width: 900,
      showCloseButton: true,
      confirmButtonText: "Close",
      confirmButtonColor: "#4f46e5",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      customClass: { popup: "swal-wide-custom" },
      didClose: closeFamilyDetails,
    }).then(closeFamilyDetails);

    return () => Swal.close();
  }, [
    isFamilyDetailsOpen,
    familyCode,
    students,
    totalStudents,
    feeSummary,
    formatCurrency,
    closeFamilyDetails,
  ]);

  // ---------- Student Details Modal (Swal) ----------
  useEffect(() => {
    if (!isStudentDetailsOpen || !studentItem) return;

    const student = studentItem.student;
    const feeDetails = studentItem.feeDetails || {};

    const html = `
    <div style="
      font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
      width: 100%; height:60vh;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        gap: 1.5rem;
        padding: 1.5rem;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border-radius: 0.75rem 0.75rem 0 0;
        color: white;
        margin-bottom: 1.5rem;
      ">
        <div style="
          width: 80px;
          height: 80px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.5rem;
          font-weight: 800;
          border: 3px solid rgba(255, 255, 255, 0.3);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        ">
          ${student.name ? student.name.charAt(0) : "S"}
        </div>
        <div>
          <h3 style="
            font-size: 1.875rem;
            font-weight: 800;
            margin: 0 0 0.5rem 0;
            letter-spacing: -0.025em;
          ">
            ${student.name || "Student"}
          </h3>
          <p style="
            font-size: 1rem;
            opacity: 0.9;
            margin: 0;
            font-weight: 500;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${student.student_id || "N/A"}
          </p>
        </div>
      </div>
      
      <!-- Grid -->
      <div style="
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        padding: 0 1.5rem;
      ">
        <!-- Father Name -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1rem;
          border: 1px solid #e5e7eb;
        ">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.5rem;
          ">
            Father Name
          </div>
          <div style="
            font-size: 1rem;
            color: #111827;
            font-weight: 600;
          ">
            ${student.father_name || "N/A"}
          </div>
        </div>
        
        <!-- Class & Section -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1rem;
          border: 1px solid #e5e7eb;
        ">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.5rem;
          ">
            Class & Section
          </div>
          <div style="
            font-size: 1rem;
            color: #111827;
            font-weight: 600;
          ">
            ${student.class || "N/A"} - ${student.section || "N/A"}
          </div>
        </div>
        
        <!-- Mobile -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1rem;
          border: 1px solid #e5e7eb;
        ">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.5rem;
          ">
            Mobile
          </div>
          <div style="
            font-size: 1rem;
            color: #111827;
            font-weight: 600;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${student.mobile || "N/A"}
          </div>
        </div>
        
        <!-- B-Form No -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1rem;
          border: 1px solid #e5e7eb;
        ">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.5rem;
          ">
            B-Form No
          </div>
          <div style="
            font-size: 1rem;
            color: #111827;
            font-weight: 600;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${student.b_form_no || "N/A"}
          </div>
        </div>
        
        <!-- Address -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1rem;
          border: 1px solid #e5e7eb;
          grid-column: span 2;
        ">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.5rem;
          ">
            Address
          </div>
          <div style="
            font-size: 1rem;
            color: #111827;
            font-weight: 500;
            line-height: 1.5;
          ">
            ${student.address || "N/A"}
          </div>
        </div>
        
        <!-- Gender -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1rem;
          border: 1px solid #e5e7eb;
        ">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.5rem;
          ">
            Gender
          </div>
          <div style="
            font-size: 1rem;
            color: #111827;
            font-weight: 600;
          ">
            ${student.gender || "N/A"}
          </div>
        </div>
        
        <!-- Family Status -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1rem;
          border: 1px solid #e5e7eb;
        ">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.5rem;
          ">
            Family Status
          </div>
          <div>
            <span style="
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
              padding: 0.25rem 0.75rem;
              border-radius: 9999px;
              font-size: 0.75rem;
              font-weight: 700;
              letter-spacing: 0.05em;
              text-transform: uppercase;
            ">
              ${student.family_status || "Family"}
            </span>
          </div>
        </div>
        
        <!-- Family Code -->
        <div style="
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
          border-radius: 0.5rem;
          padding: 1rem;
          border: 2px solid rgba(102, 126, 234, 0.3);
          grid-column: span 2;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <div>
            <div style="
              font-size: 0.75rem;
              color: #667eea;
              font-weight: 600;
              text-transform: uppercase;
              letter-spacing: 0.05em;
              margin-bottom: 0.25rem;
            ">
              Family Code
            </div>
            <div style="
              font-size: 1.25rem;
              color: #4c51bf;
              font-weight: 800;
              font-family: 'JetBrains Mono', monospace;
            ">
              ${student.family_code || familyCode}
            </div>
          </div>
          <div style="
            font-size: 2rem;
            color: #667eea;
            opacity: 0.5;
          ">
            👨‍👩‍👧‍👦
          </div>
        </div>
      </div>
      
      <!-- Fee Summary -->
      <div style="
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        padding: 1.5rem;
        margin-top: 1.5rem;
        background: #f8fafc;
        border-radius: 0 0 0.75rem 0.75rem;
        border-top: 2px solid #e5e7eb;
      ">
        <div style="
          background: white;
          border-radius: 0.5rem;
          padding: 1.25rem;
          border: 2px solid rgba(16, 185, 129, 0.2);
          box-shadow: 0 2px 8px rgba(16, 185, 129, 0.1);
        ">
          <div style="
            font-size: 0.875rem;
            color: #6b7280;
            font-weight: 600;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          ">
            <span style="
              width: 8px;
              height: 8px;
              background: #10b981;
              border-radius: 50%;
              display: inline-block;
            "></span>
            Monthly Fee
          </div>
          <div style="
            font-size: 1.75rem;
            color: #10b981;
            font-weight: 800;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${formatCurrency(feeDetails.monthly_fee || 0)}
          </div>
        </div>
        
        <div style="
          background: white;
          border-radius: 0.5rem;
          padding: 1.25rem;
          border: 2px solid rgba(37, 99, 235, 0.2);
          box-shadow: 0 2px 8px rgba(37, 99, 235, 0.1);
        ">
          <div style="
            font-size: 0.875rem;
            color: #6b7280;
            font-weight: 600;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          ">
            <span style="
              width: 8px;
              height: 8px;
              background: #2563eb;
              border-radius: 50%;
              display: inline-block;
            "></span>
            Total Payable
          </div>
          <div style="
            font-size: 1.75rem;
            color: #2563eb;
            font-weight: 800;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${formatCurrency(feeDetails.total_payable || 0)}
          </div>
        </div>
      </div>
    </div>
    `;

    Swal.fire({
      title: "Student Details",
      html,
      width: 700,
      showCloseButton: true,
      confirmButtonText: "Close",
      confirmButtonColor: "#667eea",
      showConfirmButton: true,
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      focusConfirm: false,
      customClass: { popup: "swal-wide-custom" },
      didOpen: () => {
        const containers = document.querySelectorAll(".swal2-container");
        if (containers.length > 1) {
          for (let i = 0; i < containers.length - 1; i++) {
            containers[i].remove();
          }
        }
      },
      didClose: closeStudentDetails,
    }).then(closeStudentDetails);

    return () => Swal.close();
  }, [
    isStudentDetailsOpen,
    studentItem,
    familyCode,
    formatCurrency,
    closeStudentDetails,
  ]);

  // ---------- Fee Details Modal (Swal) ----------
  useEffect(() => {
    if (!isFeeDetailsOpen || !studentItem) return;

    const student = studentItem.student;
    const feeDetails = studentItem.feeDetails || {};

    const html = `
    <div style="
      font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
      width: 100%;
    ">
      <!-- Header -->
      <div style="
        text-align: center;
        padding: 1.5rem;
        background: linear-gradient(135deg, #10b981 0%, #3b82f6 100%);
        border-radius: 0.75rem 0.75rem 0 0;
        color: white;
        margin-bottom: 1.5rem;
        position: relative;
        overflow: hidden;
      ">
        <div style="
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
          background-size: 200% 200%;
          animation: shimmer 3s infinite linear;
        "></div>
        <h4 style="
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 0 0.5rem 0;
          position: relative;
          z-index: 1;
        ">
          ${student.name || "Student"}
        </h4>
        <p style="
          font-size: 1rem;
          opacity: 0.9;
          margin: 0;
          font-weight: 500;
          position: relative;
          z-index: 1;
        ">
          ${student.class || ""} ${student.section || ""}
        </p>
        <div style="
          position: absolute;
          top: 1rem;
          right: 1rem;
          font-size: 2rem;
          opacity: 0.2;
          z-index: 1;
        ">
          💰
        </div>
      </div>
      
      <!-- Fee Grid -->
      <div style="
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 1rem;
        padding: 0 1.5rem;
      ">
        <!-- Annual Charges -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1.25rem;
          border: 1px solid #e5e7eb;
          transition: all 0.2s ease;
        " onmouseenter="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(0, 0, 0, 0.1)'; this.style.borderColor='#f59e0b'"
          onmouseleave="this.style.transform='translateY(0)'; this.style.boxShadow='none'; this.style.borderColor='#e5e7eb'">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          ">
            <span style="
              width: 8px;
              height: 8px;
              background: #f59e0b;
              border-radius: 50%;
              display: inline-block;
            "></span>
            Annual Charges
          </div>
          <div style="
            font-size: 1.5rem;
            color: #f59e0b;
            font-weight: 800;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${formatCurrency(feeDetails.annual_charges || 0)}
          </div>
        </div>
        
        <!-- Admission Fee -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1.25rem;
          border: 1px solid #e5e7eb;
          transition: all 0.2s ease;
        " onmouseenter="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(0, 0, 0, 0.1)'; this.style.borderColor='#8b5cf6'"
          onmouseleave="this.style.transform='translateY(0)'; this.style.boxShadow='none'; this.style.borderColor='#e5e7eb'">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          ">
            <span style="
              width: 8px;
              height: 8px;
              background: #8b5cf6;
              border-radius: 50%;
              display: inline-block;
            "></span>
            Admission Fee
          </div>
          <div style="
            font-size: 1.5rem;
            color: #8b5cf6;
            font-weight: 800;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${formatCurrency(feeDetails.admission_fee || 0)}
          </div>
        </div>
        
        <!-- Workbook Charges -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1.25rem;
          border: 1px solid #e5e7eb;
          transition: all 0.2s ease;
        " onmouseenter="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(0, 0, 0, 0.1)'; this.style.borderColor='#ec4899'"
          onmouseleave="this.style.transform='translateY(0)'; this.style.boxShadow='none'; this.style.borderColor='#e5e7eb'">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          ">
            <span style="
              width: 8px;
              height: 8px;
              background: #ec4899;
              border-radius: 50%;
              display: inline-block;
            "></span>
            Workbook Charges
          </div>
          <div style="
            font-size: 1.5rem;
            color: #ec4899;
            font-weight: 800;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${formatCurrency(feeDetails.workbook_charges || 0)}
          </div>
        </div>
        
        <!-- Book Charges -->
        <div style="
          background: #f9fafb;
          border-radius: 0.5rem;
          padding: 1.25rem;
          border: 1px solid #e5e7eb;
          transition: all 0.2s ease;
        " onmouseenter="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(0, 0, 0, 0.1)'; this.style.borderColor='#3b82f6'"
          onmouseleave="this.style.transform='translateY(0)'; this.style.boxShadow='none'; this.style.borderColor='#e5e7eb'">
          <div style="
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.05em;
            margin-bottom: 0.75rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          ">
            <span style="
              width: 8px;
              height: 8px;
              background: #3b82f6;
              border-radius: 50%;
              display: inline-block;
            "></span>
            Book Charges
          </div>
          <div style="
            font-size: 1.5rem;
            color: #3b82f6;
            font-weight: 800;
            font-family: 'JetBrains Mono', monospace;
          ">
            ${formatCurrency(feeDetails.book_charges || 0)}
          </div>
        </div>
        
        <!-- Monthly Fee -->
        <div style="
          background: linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%);
          border-radius: 0.5rem;
          padding: 1.5rem;
          border: 2px solid rgba(16, 185, 129, 0.3);
          grid-column: span 1;
          transition: all 0.2s ease;
          position: relative;
          overflow: hidden;
        " onmouseenter="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 8px 25px rgba(16, 185, 129, 0.2)'"
          onmouseleave="this.style.transform='translateY(0)'; this.style.boxShadow='none'">
          <div style="
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
            transition: left 0.7s ease;
          " onmouseenter="this.style.left='100%'"></div>
          <div style="
            font-size: 0.75rem;
            color: #10b981;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            margin-bottom: 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
          ">
            <span>Monthly Fee</span>
            <span style="
              background: #10b981;
              color: white;
              padding: 0.25rem 0.75rem;
              border-radius: 9999px;
              font-size: 0.625rem;
            ">
              RECURRING
            </span>
          </div>
          <div style="
            font-size: 2rem;
            color: #10b981;
            font-weight: 900;
            font-family: 'JetBrains Mono', monospace;
            text-align: center;
          ">
            ${formatCurrency(feeDetails.monthly_fee || 0)}
          </div>
          <div style="
            font-size: 0.75rem;
            color: #059669;
            text-align: center;
            margin-top: 0.5rem;
            font-weight: 500;
          ">
            Per Month
          </div>
        </div>
        
        <!-- Total Payable -->
        <div style="
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(37, 99, 235, 0.05) 100%);
          border-radius: 0.5rem;
          padding: 1.5rem;
          border: 2px solid rgba(37, 99, 235, 0.3);
          grid-column: span 1;
          transition: all 0.2s ease;
          position: relative;
          overflow: hidden;
        " onmouseenter="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 8px 25px rgba(37, 99, 235, 0.2)'"
          onmouseleave="this.style.transform='translateY(0)'; this.style.boxShadow='none'">
          <div style="
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
            transition: left 0.7s ease;
          " onmouseenter="this.style.left='100%'"></div>
          <div style="
            font-size: 0.75rem;
            color: #2563eb;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            margin-bottom: 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
          ">
            <span>Total Payable</span>
            <span style="
              background: #2563eb;
              color: white;
              padding: 0.25rem 0.75rem;
              border-radius: 9999px;
              font-size: 0.625rem;
            ">
              TOTAL
            </span>
          </div>
          <div style="
            font-size: 2.5rem;
            color: #2563eb;
            font-weight: 900;
            font-family: 'JetBrains Mono', monospace;
            text-align: center;
          ">
            ${formatCurrency(feeDetails.total_payable || 0)}
          </div>
          <div style="
            font-size: 0.75rem;
            color: #1d4ed8;
            text-align: center;
            margin-top: 0.5rem;
            font-weight: 500;
          ">
            One-Time Payment
          </div>
        </div>
      </div>
      
      <!-- Summary Bar -->
      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem 1.5rem;
        margin-top: 1.5rem;
        background: linear-gradient(135deg, #1f2937 0%, #374151 100%);
        border-radius: 0.5rem;
        color: white;
      ">
        <div style="
          display: flex;
          align-items: center;
          gap: 0.5rem;
        ">
          <span style="
            font-size: 1.5rem;
          ">📊</span>
          <div>
            <div style="
              font-size: 0.75rem;
              opacity: 0.8;
              font-weight: 500;
            ">
              Fee Breakdown Summary
            </div>
            <div style="
              font-size: 0.875rem;
              font-weight: 600;
            ">
              All charges are inclusive of taxes
            </div>
          </div>
        </div>
        <div style="
          font-size: 1rem;
          font-weight: 700;
          font-family: 'JetBrains Mono', monospace;
          background: rgba(255, 255, 255, 0.1);
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
        ">
          ${formatCurrency(feeDetails.total_payable || 0)}
        </div>
      </div>
    </div>
    `;

    Swal.fire({
      title: `Fee Details - ${student.name || "Student"}`,
      html,
      width: 600,
      showCloseButton: true,
      confirmButtonText: "Close",
      confirmButtonColor: "#10b981",
      showConfirmButton: true,
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      focusConfirm: false,
      customClass: { popup: "swal-wide-custom" },
      didOpen: () => {
        const containers = document.querySelectorAll(".swal2-container");
        if (containers.length > 1) {
          for (let i = 0; i < containers.length - 1; i++) {
            containers[i].remove();
          }
        }
      },
      didClose: closeFeeDetails,
    }).then(closeFeeDetails);

    return () => Swal.close();
  }, [isFeeDetailsOpen, studentItem, formatCurrency, closeFeeDetails]);

  // ---------- Family Fee Records Modal (Swal) ----------
  useEffect(() => {
    if (!isFeeRecordsOpen || !feeRecords) return;

    const generateFeeRecordsHTML = () => {
      let recordsHTML = `
      <div style="
        font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
        color: #333; height:50vh;
        padding: 10px;
      ">
        <h4 style="
          color: #4f46e5;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 2px solid #e5e7eb;
          font-size: 18px;
          font-weight: 600;
        ">
          Existing Family Fee Records for ${familyCode}
        </h4>
        
        <div style="
          margin-bottom: 25px;
          overflow-x: auto;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        ">
          <table style="
            width: 100%;
            border-collapse: collapse;
            font-size: 14px;
            min-width: 900px;
          ">
            <thead style="
              background-color: #4f46e5;
              color: white;
            ">
              <tr>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Record ID</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Student Name</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Student ID</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Monthly Fee</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Total Paid</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                  border-right: 1px solid rgba(255, 255, 255, 0.2);
                ">Balance</th>
                <th style="
                  padding: 12px 16px;
                  text-align: left;
                  font-weight: 600;
                ">Created</th>
              </tr>
            </thead>
            <tbody>
      `;

      if (feeRecords.records && feeRecords.records.length > 0) {
        feeRecords.records.forEach((record) => {
          const balance = record.last_pendings || 0;
          recordsHTML += `
          <tr style="
            border-bottom: 1px solid #e5e7eb;
            transition: background-color 0.2s;
          " onmouseover="this.style.backgroundColor='#f9fafb'" onmouseout="this.style.backgroundColor='transparent'">
            <td style="
              padding: 12px 16px;
              border-right: 1px solid #e5e7eb;
              font-family: 'Monaco', 'Courier New', monospace;
              font-weight: 500;
            ">${record.id || "N/A"}</td>
            <td style="
              padding: 12px 16px;
              border-right: 1px solid #e5e7eb;
              font-weight: 500;
            ">${record.student_name || "Family Record"}</td>
            <td style="
              padding: 12px 16px;
              border-right: 1px solid #e5e7eb;
              font-family: 'Monaco', 'Courier New', monospace;
            ">${record.student_id || "N/A"}</td>
            <td style="
              padding: 12px 16px;
              border-right: 1px solid #e5e7eb;
              text-align: right;
              font-weight: 500;
              color: #059669;
              font-family: 'Monaco', 'Courier New', monospace;
            ">${formatCurrency(record.monthly_fee || 0)}</td>
            <td style="
              padding: 12px 16px;
              border-right: 1px solid #e5e7eb;
              text-align: right;
              font-weight: 500;
              color: #2563eb;
              font-family: 'Monaco', 'Courier New', monospace;
            ">${formatCurrency(record.total_paid || 0)}</td>
            <td style="
              padding: 12px 16px;
              border-right: 1px solid #e5e7eb;
              text-align: right;
              font-weight: 600;
              color: ${balance > 0 ? "#dc2626" : "#059669"};
              font-family: 'Monaco', 'Courier New', monospace;
            ">${formatCurrency(balance)}</td>
            <td style="
              padding: 12px 16px;
              text-align: center;
              font-family: 'Monaco', 'Courier New', monospace;
            ">${moment(record.created_at).format("DD-MM-YYYY")}</td>
          </tr>
        `;
        });
      } else {
        recordsHTML += `
        <tr>
          <td colspan="7" style="
            text-align: center;
            padding: 40px 20px;
            color: #6b7280;
            font-style: italic;
            background-color: #f9fafb;
          ">
            No fee records found
          </td>
        </tr>
      `;
      }

      recordsHTML += `
            </tbody>
          </table>
        </div>
        
        <div style="
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 16px;
          padding: 20px;
          background-color: #f8f9fa;
          border-radius: 8px;
          border: 1px solid #e5e7eb;
          margin-bottom: 20px;
        ">
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            background: white;
            border-radius: 6px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            border: 1px solid #e5e7eb;
          ">
            <span style="
              font-size: 14px;
              color: #6b7280;
              margin-bottom: 8px;
            ">Total Records</span>
            <strong style="
              font-size: 24px;
              color: #4f46e5;
              font-weight: 700;
            ">${feeRecords.record_count || 0}</strong>
          </div>
          
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            background: white;
            border-radius: 6px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            border: 1px solid #e5e7eb;
          ">
            <span style="
              font-size: 14px;
              color: #6b7280;
              margin-bottom: 8px;
            ">Students in Family</span>
            <strong style="
              font-size: 24px;
              color: #059669;
              font-weight: 700;
            ">${feeRecords.student_count || 0}</strong>
          </div>
          
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 16px;
            background: white;
            border-radius: 6px;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            border: 1px solid #e5e7eb;
          ">
            <span style="
              font-size: 14px;
              color: #6b7280;
              margin-bottom: 8px;
            ">Coverage</span>
            <strong style="
              font-size: 20px;
              color: #f59e0b;
              font-weight: 700;
              padding: 4px 12px;
              background-color: #fef3c7;
              border-radius: 20px;
            ">${feeRecords.summary?.coverage || "N/A"}</strong>
          </div>
        </div>
        
        <div style="
          padding: 16px;
          background-color: #fef2f2;
          border-radius: 8px;
          border: 1px solid #fecaca;
          display: flex;
          align-items: flex-start;
          gap: 12px;
        ">
          <span style="
            color: #dc2626;
            font-size: 18px;
            flex-shrink: 0;
            margin-top: 2px;
          ">⚠️</span>
          <p style="
            color: #b91c1c;
            font-size: 14px;
            margin: 0;
            line-height: 1.5;
          ">
            <strong>Warning:</strong> Creating a new record may cause duplicates. Consider updating existing records instead.
          </p>
        </div>
      </div>
      `;
      return recordsHTML;
    };

    Swal.fire({
      title: "Existing Family Fee Records",
      html: generateFeeRecordsHTML(),
      width: 1000,
      showCloseButton: true,
      confirmButtonText: "Close",
      confirmButtonColor: "#4f46e5",
      showCancelButton: true,
      cancelButtonText: "Update Existing",
      cancelButtonColor: "#f59e0b",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      customClass: { popup: "swal-wide-custom" },
      didClose: closeFeeRecords,
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        onUpdateExisting?.();
      }
      closeFeeRecords();
    });

    return () => Swal.close();
  }, [
    isFeeRecordsOpen,
    feeRecords,
    familyCode,
    formatCurrency,
    onUpdateExisting,
    closeFeeRecords,
  ]);

  // ---------- Update Success Alert (Swal) ----------
  useEffect(() => {
    if (!isUpdateSuccessOpen) return;

    const html = `
    <div style="
      font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
      color: #333; height:50vh;
      text-align: center;
      padding: 20px 0;
    ">
      <div style="
        font-size: 64px;
        color: #059669;
        margin-bottom: 16px;
        animation: bounce 0.5s;
      ">✓</div>
      <h3 style="
        margin: 0 0 12px 0;
        color: #1f2937;
        font-size: 24px;
        font-weight: 700;
      ">
        Family Record Updated Successfully!
      </h3>
      <p style="
        margin: 0 0 24px 0;
        color: #6b7280;
        line-height: 1.5;
        font-size: 16px;
      ">
        The family fee record for <strong style="color: #4f46e5;">${familyCode}</strong> has been updated.
      </p>
      
      <div style="
        background-color: #f0fdf4;
        border-radius: 8px;
        padding: 20px;
        margin: 24px 0;
        border: 1px solid #a7f3d0;
      ">
        <div style="
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 16px;
        ">
          <div style="
            font-size: 24px;
            color: #059669;
          ">👨‍👩‍👧‍👦</div>
          <div>
            <div style="
              font-size: 12px;
              color: #6b7280;
              text-transform: uppercase;
              letter-spacing: 0.5px;
            ">Family Updated</div>
            <div style="
              font-size: 18px;
              color: #1f2937;
              font-weight: 600;
            ">${familyCode}</div>
          </div>
        </div>
        
        <div style="
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        ">
          <div style="
            background-color: white;
            padding: 12px;
            border-radius: 6px;
            border: 1px solid #e5e7eb;
          ">
            <div style="
              font-size: 12px;
              color: #6b7280;
              margin-bottom: 4px;
            ">Students</div>
            <div style="
              font-size: 18px;
              color: #059669;
              font-weight: 600;
            ">${totalStudents}</div>
          </div>
          
          <div style="
            background-color: white;
            padding: 12px;
            border-radius: 6px;
            border: 1px solid #e5e7eb;
          ">
            <div style="
              font-size: 12px;
              color: #6b7280;
              margin-bottom: 4px;
            ">New Balance</div>
            <div style="
              font-size: 18px;
              color: ${lastPending > 0 ? "#dc2626" : "#059669"};
              font-weight: 600;
            ">${formatCurrency(lastPending)}</div>
          </div>
        </div>
      </div>
      
      <p style="
        color: #6b7280;
        font-size: 14px;
        margin-top: 20px;
        padding-top: 16px;
        border-top: 1px solid #e5e7eb;
      ">
        The update has been saved to the database. You can continue with other operations.
      </p>
    </div>
    `;

    Swal.fire({
      title: "Success!",
      html,
      icon: "success",
      confirmButtonText: "Continue",
      confirmButtonColor: "#059669",
      width: 500,
      timer: 5000,
      timerProgressBar: true,
      showCloseButton: true,
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      customClass: { popup: "swal-success-custom" },
      didClose: closeUpdateSuccess,
    }).then(closeUpdateSuccess);

    return () => Swal.close();
  }, [
    isUpdateSuccessOpen,
    familyCode,
    totalStudents,
    lastPending,
    formatCurrency,
    closeUpdateSuccess,
  ]);

  return (
    <>
      {/* Custom JSX Modals */}
      <FamilyCheckDialog
        isOpen={isFamilyCheckOpen}
        onClose={closeFamilyCheck}
        familyCheckResult={familyCheckResult}
        familyCode={familyCode}
        onUpdate={onFamilyCheckUpdate}
        onView={onFamilyCheckView}
        onSubmitNew={onFamilyCheckSubmitNew}
      />
    </>
  );
};

// =============================================================================
// 3. EXPORT PROMISE-BASED CONFIRMATION DIALOGS (imperative)
// =============================================================================

export const showUpdateConfirmation = async ({
  familyCode,
  totalStudents,
  totalPayable,
  discountPercentage,
  finalTotal,
  paidAmount,
  lastPending,
  formatCurrency,
}) => {
  return Swal.fire({
    title: "Update Family Record?",
    html: `
    <div style="
      font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
      color: #333; height:50vh;
    ">
      <div style="
        text-align: center;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 1px solid #e5e7eb;
      ">
        <div style="
          font-size: 40px;
          color: #f59e0b;
          margin-bottom: 12px;
        ">✏️</div>
        <h3 style="
          margin: 0 0 8px 0;
          color: #1f2937;
          font-size: 20px;
          font-weight: 600;
        ">
          Update Family Fee Record
        </h3>
        <p style="
          margin: 0;
          color: #6b7280;
          line-height: 1.5;
        ">
          This will update the existing family fee record for 
          <strong style="color: #4f46e5;">${familyCode}</strong>.
        </p>
      </div>
      
      <div style="
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 20px;
        border: 1px solid #e5e7eb;
      ">
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Family Code:</span>
          <strong style="
            color: #4f46e5;
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
          ">${familyCode}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Students:</span>
          <strong style="
            color: #059669;
            flex: 1;
            text-align: right;
            font-size: 18px;
          ">${totalStudents}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Total Payable:</span>
          <strong style="
            color: #dc2626;
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
          ">${formatCurrency(totalPayable)}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Discount:</span>
          <strong style="
            color: #f59e0b;
            flex: 1;
            text-align: right;
            font-size: 18px;
          ">${discountPercentage}%</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Final Total:</span>
          <strong style="
            color: #059669;
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
            font-size: 18px;
            font-weight: 700;
          ">${formatCurrency(finalTotal)}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Amount to Update:</span>
          <strong style="
            color: #2563eb;
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
            font-size: 18px;
            font-weight: 700;
            background-color: #eff6ff;
            padding: 4px 12px;
            border-radius: 4px;
            display: inline-block;
          ">${formatCurrency(paidAmount)}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          background-color: #f3f4f6;
          margin: 0 -16px;
          padding: 12px 16px;
          border-radius: 0 0 8px 8px;
        ">
          <span style="
            color: #1f2937;
            font-weight: 600;
            flex: 1;
          ">New Balance:</span>
          <strong style="
            color: ${lastPending > 0 ? "#dc2626" : "#059669"};
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
            font-size: 20px;
            font-weight: 700;
            padding: 4px 12px;
            background-color: white;
            border-radius: 4px;
            border: 2px solid ${lastPending > 0 ? "#fecaca" : "#a7f3d0"};
            display: inline-block;
          ">${formatCurrency(lastPending)}</strong>
        </div>
      </div>
      
      <div style="
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px;
        background-color: #eff6ff;
        border-radius: 8px;
        border: 1px solid #bfdbfe;
      ">
        <div style="
          font-size: 20px;
          color: #2563eb;
          flex-shrink: 0;
          margin-top: 2px;
        ">ℹ️</div>
        <span style="
          color: #1e40af;
          font-size: 14px;
          line-height: 1.5;
        ">
          <strong>Note:</strong> All family fee fields will be updated with the new values.
        </span>
      </div>
    </div>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Update Family Record",
    cancelButtonText: "Cancel",
    width: 600,
    showCloseButton: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    backdrop: true,
    confirmButtonColor: "#4f46e5",
    cancelButtonColor: "#6b7280",
    customClass: {
      confirmButton: "swal-confirm-button",
      cancelButton: "swal-cancel-button",
    },
  });
};

export const showSubmitConfirmation = async ({
  familyCode,
  totalStudents,
  totalPayable,
  paidAmount,
  formatCurrency,
}) => {
  return Swal.fire({
    title: "Submit New Family Record?",
    html: `
    <div style="
      font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
      color: #333; height:50vh;
    ">
      <div style="
        text-align: center;
        margin-bottom: 24px;
        padding-bottom: 16px;
        border-bottom: 1px solid #e5e7eb;
      ">
        <div style="
          font-size: 48px;
          color: #059669;
          margin-bottom: 12px;
        ">📤</div>
        <h3 style="
          margin: 0 0 8px 0;
          color: #1f2937;
          font-size: 20px;
          font-weight: 600;
        ">
          Submit New Family Fee Record
        </h3>
        <p style="
          margin: 0;
          color: #6b7280;
          line-height: 1.5;
        ">
          This will create a new family fee record for 
          <strong style="color: #4f46e5;">${familyCode}</strong>.
        </p>
      </div>
      
      <div style="
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 20px;
        border: 1px solid #e5e7eb;
      ">
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Family Code:</span>
          <strong style="
            color: #4f46e5;
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
            font-size: 16px;
          ">${familyCode}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Students:</span>
          <strong style="
            color: #059669;
            flex: 1;
            text-align: right;
            font-size: 18px;
          ">${totalStudents}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          border-bottom: 1px solid #e9ecef;
        ">
          <span style="
            color: #4b5563;
            font-weight: 500;
            flex: 1;
          ">Total Payable:</span>
          <strong style="
            color: #dc2626;
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
            font-size: 16px;
          ">${formatCurrency(totalPayable)}</strong>
        </div>
        
        <div style="
          display: flex;
          justify-content: space-between;
          padding: 12px 0;
          background-color: #f3f4f6;
          margin: 0 -16px;
          padding: 12px 16px;
          border-radius: 0 0 8px 8px;
        ">
          <span style="
            color: #1f2937;
            font-weight: 600;
            flex: 1;
          ">Amount to Submit:</span>
          <strong style="
            color: #2563eb;
            flex: 1;
            text-align: right;
            font-family: 'Monaco', 'Courier New', monospace;
            font-size: 20px;
            font-weight: 700;
            padding: 4px 12px;
            background-color: white;
            border-radius: 4px;
            border: 2px solid #bfdbfe;
            display: inline-block;
          ">${formatCurrency(paidAmount)}</strong>
        </div>
      </div>
      
      <div style="
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px;
        background-color: #f0fdf4;
        border-radius: 8px;
        border: 1px solid #a7f3d0;
      ">
        <div style="
          font-size: 20px;
          color: #059669;
          flex-shrink: 0;
          margin-top: 2px;
        ">📝</div>
        <span style="
          color: #065f46;
          font-size: 14px;
          line-height: 1.5;
        ">
          <strong>Note:</strong> This will create a new family fee record in the system.
        </span>
      </div>
    </div>
    `,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Submit New Family Record",
    cancelButtonText: "Cancel",
    width: 600,
    showCloseButton: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    backdrop: true,
    confirmButtonColor: "#059669",
    cancelButtonColor: "#6b7280",
    customClass: {
      confirmButton: "swal-confirm-button",
      cancelButton: "swal-cancel-button",
    },
  });
};

export default Modals;